import React from 'react'
import RouterScreen from './containers/RouterScreen'

const App = () => {
  return <RouterScreen />
}

export default App
